const React = require("react");

//* Any scripts that need to be injected in head
exports.onClientEntry = () => {
  console.log('Plugins')
};